<template>
  <q-dialog class="theme-1" v-model="show" position="top" >
    <div class="card bg-white mt-4">
      <div class="card-body">
      
        <span class="font-size-14 d-block">{{dialogState.message}}</span>
        
      </div>

      <div class="card-footer d-flex justify-content-end">
       
        <q-btn color="transparent" class="btn text-body mr-2" :label="$t('main.confirmationDialog.cancelButton')" @click="onCancel" />
        <q-btn class="btn btn-info" :label="$t('printDocument.confirmationDialog.waitButton')" @click="onConfirm"/>
        </div>
    
    </div>

  </q-dialog>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {Emit} from "vue-property-decorator";
import store from "@/store";
import router from "@/router";
import {Notify} from "quasar";
import i18n from "@/i18n";

@Options({
  props: {
    show: Boolean
  }
})
export default class PrintDocumentConfirmationDialog extends Vue {

  name = 'confirmation-dialog'
  show?: boolean;

  get dialogState() {
    return store.state.printDocumentModule.printDocumentConfirmationDialogState
  }

  @Emit("onConfirm")
  async onConfirm() {
  //   TODO finish when remove mock
    await store.dispatch('printDocumentModule/hideConfirmationDialog')
    setTimeout(() => {
      Notify.create({
        message: i18n.global.t('printDocument.confirmationDialog.waitTimeout'),
        color: 'warning'
      })
      this.closeModal()
    }, 5000)
  
  }

  @Emit("onCancel")
  onCancel() {
    this.closeModal()
  }

  async closeModal() {
    await store.dispatch('printDocumentModule/cleanConfirmationDialogState')
    await store.dispatch('printDocumentModule/toggleShow')
  }

}
</script>

<style scoped>
button{
  border-radius: 10px;
}
</style>
